import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogBaseComponent } from '@volt/shared/components/dialogs/dynamic-dialog/dynamic-dialog-base.component';

@Component({
  selector: 'fields-info-modal',
  templateUrl: './fields-info-modal.component.html',
  styleUrls: [],
})
export class FieldsInfoModalComponent extends DynamicDialogBaseComponent implements OnInit {
  messages: string[];

  constructor(
    public readonly _dialogReference: DynamicDialogRef,
    private readonly _dialogConfig: DynamicDialogConfig,
    private _router: Router,
  ) {
    super(_dialogReference, _dialogConfig);
  }

  ngOnInit() {
    this._router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this._dialogReference.close(false));

    this.messages = this._dialogConfig.data.messages;
  }

  public onClose() {
    this._dialogReference.close();
  }
}
